// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ActiveStorageAttachment from "./active-storage-attachment.js"
import Reimbursement from "./reimbursement.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "amount": {
      "column": null,
      "name": "amount",
      "selected_by_default": null,
      "translated": null
    },
    "amount_cents": {
      "column": {
        "default": null,
        "name": "amount_cents",
        "null": true,
        "type": "integer"
      },
      "name": "amount_cents",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "date": {
      "column": {
        "default": null,
        "name": "date",
        "null": true,
        "type": "date"
      },
      "name": "date",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "description": {
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      },
      "name": "description",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "reimbursement_id": {
      "column": {
        "default": null,
        "name": "reimbursement_id",
        "null": true,
        "type": "uuid"
      },
      "name": "reimbursement_id",
      "selected_by_default": null,
      "translated": null
    },
    "user_id": {
      "column": {
        "default": null,
        "name": "user_id",
        "null": true,
        "type": "uuid"
      },
      "name": "user_id",
      "selected_by_default": null,
      "translated": null
    },
    "content_type": {
      "column": null,
      "name": "content_type",
      "selected_by_default": false,
      "translated": null
    },
    "url": {
      "column": null,
      "name": "url",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "ReimbursementAttachment",
  "collectionKey": "reimbursement_attachments",
  "collectionName": "reimbursement_attachments",
  "i18nKey": "reimbursement_attachment",
  "camelizedLower": "reimbursementAttachment",
  "name": "ReimbursementAttachment",
  "nameDasherized": "reimbursement-attachment",
  "pluralName": "reimbursement_attachments",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "attachment_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "attachment_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "attachment_attachment"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Reimbursement",
      "collectionName": "reimbursements",
      "foreignKey": "reimbursement_id",
      "name": "reimbursement",
      "macro": "belongs_to",
      "resource_name": "Reimbursement",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "amount_cents",
      "column": {
        "default": null,
        "name": "amount_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_currency",
      "column": {
        "default": null,
        "name": "amount_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "date",
      "column": {
        "default": null,
        "name": "date",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_reimbursement_id",
      "column": {
        "default": null,
        "name": "old_reimbursement_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_user_id",
      "column": {
        "default": null,
        "name": "old_user_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "reimbursement_id",
      "column": {
        "default": null,
        "name": "reimbursement_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": true,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "attachment_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "Reimbursement",
      "collectionName": "reimbursements",
      "foreignKey": "reimbursement_id",
      "name": "reimbursement",
      "macro": "belongs_to",
      "resource_name": "Reimbursement",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "reimbursement_attachment",
  "primaryKey": "id"
}

/** Frontend model for ReimbursementAttachment. */
export default class ReimbursementAttachment extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  amount() {
    return this.readAttributeUnderscore("amount")
  }

  /** @returns {boolean} */
  hasAmount() {
    const value = this.amount()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  amountCents() {
    return this.readAttributeUnderscore("amount_cents")
  }

  /** @returns {boolean} */
  hasAmountCents() {
    const value = this.amountCents()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  date() {
    return this.readAttributeUnderscore("date")
  }

  /** @returns {boolean} */
  hasDate() {
    const value = this.date()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  reimbursementId() {
    return this.readAttributeUnderscore("reimbursement_id")
  }

  /** @returns {boolean} */
  hasReimbursementId() {
    const value = this.reimbursementId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  userId() {
    return this.readAttributeUnderscore("user_id")
  }

  /** @returns {boolean} */
  hasUserId() {
    const value = this.userId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  contentType() {
    return this.readAttributeUnderscore("content_type")
  }

  /** @returns {boolean} */
  hasContentType() {
    const value = this.contentType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  url() {
    return this.readAttributeUnderscore("url")
  }

  /** @returns {boolean} */
  hasUrl() {
    const value = this.url()

    return this._isPresent(value)
  }

  /** @returns {import("./active-storage-attachment.js").default | null} */
  attachmentAttachment() {
    return this._readHasOneReflection({modelClass: ActiveStorageAttachment, reflectionName: "attachment_attachment"})
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  loadAttachmentAttachment() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["record_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "attachment_attachment",
        model: this,
        modelClass: ActiveStorageAttachment
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  ensureAttachmentAttachmentLoaded() {
    return this.ensureAssociationLoaded("attachment_attachment")
  }

  /** @returns {import("./reimbursement.js").default | null} */
  reimbursement() {
    return this._readBelongsToReflection({modelClass: Reimbursement, reflectionName: "reimbursement"})
  }

  /** @returns {Promise<import("./reimbursement.js").default | null>} */
  loadReimbursement() {
    if (!("reimbursementId" in this)) throw new Error("Foreign key method wasn't defined: reimbursementId")

    const id = this.reimbursementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "reimbursement",
        model: this,
        modelClass: Reimbursement
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./reimbursement.js").default | null>} */
  ensureReimbursementLoaded() {
    return this.ensureAssociationLoaded("reimbursement")
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("userId" in this)) throw new Error("Foreign key method wasn't defined: userId")

    const id = this.userId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
